<template>
  <div class="row">
    <div class="col-xs-12 col-sm-6">
      <table class="table table-sm table-borderless">
        <tr>
          <th style="max-width: 330px;">RLISS</th>
          <td style="max-width: 330px;">{{info.rliss_fr}}</td>
        </tr>
        <tr>
          <th>% Pop. franco.</th>
          <td>{{info.total_percentage_francophone}}</td>
        </tr>
        <tr>
          <th>% Clientèle francophone</th>
          <td>{{percentClientFr}}</td>
        </tr>
        <tr>
          <th>Statut</th>
          <td>{{info.agency_status_fr}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'OnRatiosEmploisAgency',
  props: {
    agencyId: String,
    period: String
  },
  data() {
    return {
      info: {
        agency_fr: '',
        agency_status_fr: '',
        rliss_fr: '',
        client_french_percent: 0,
        client_french_visits_percent: 0
      }
    }
  },
  computed: {
    percentClientFr() {
      return this.info.client_french_percent || this.info.client_french_visits_percent;
    }
  },
  watch: {
    period() {
      this.refresh();
    }
  },
  methods: {
    refresh() {
      axios
          .get(this.$root.$data.server_base + '/api/on/agency_svc.php',
              {
                params: {
                  agency_id : this.agencyId,
                  period: this.period
                }
              }
          ).then(rsp => {
        this.info = rsp.data.agencyInfo;
      });
    }
  },
  mounted() {
    this.refresh();
  }
}

</script>